import { Component, Input, OnChanges, OnDestroy } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { take } from 'rxjs/operators';
import { DwEventService, DwOrmDataService, DwSecurityUserService } from '@devwareapps/devware-cap';
import { AppMetaData } from '../../../meta-data/app-meta-data.service';
import { Announcement, AnnouncementsService } from '../services/announcements.service';

@Component({ selector: 'app-central-announcements', templateUrl: './announcements.component.html', styleUrls: ['./announcements.component.scss'] })
export class AnnouncementsComponent implements OnChanges, OnDestroy {
    @Input() challengeId: number;
    rows: Announcement[] = [];
    loading = false;
    showAll = false;
    private _generation = 0;
    private _request = new Subscription();
    private _subscriptions = new Subscription();
    constructor(private announcements: AnnouncementsService, events: DwEventService, security: DwSecurityUserService) {
        this._subscriptions.add(events.getEvent(DwOrmDataService.ORM_EVENT_TOPICS.ItemChangedTopic(AppMetaData.DwAnnouncement.ItemDetail.itemName)).subscribe(() => this.load()));
        this._subscriptions.add(security.securityContextChanged().subscribe(() => { this.rows = []; this.showAll = false; this.load(); }));
        // Date changes, newly published content and changes from another admin session become visible.
        this._subscriptions.add(timer(60000, 60000).subscribe(() => this.load(false)));
    }
    get visible(): Announcement[] { return this.showAll ? this.rows : this.rows.slice(0, 3); }
    ngOnChanges(): void { this.rows = []; this.showAll = false; this.load(); }
    load(showLoading = true): void {
        this._request.unsubscribe(); this._request = new Subscription();
        const generation = ++this._generation;
        if (!(this.challengeId > 0)) { this.rows = []; this.loading = false; return; }
        this.loading = showLoading && !this.rows.length;
        this._request.add(this.announcements.read(this.challengeId).pipe(take(1)).subscribe(rows => {
            if (generation !== this._generation) return;
            this.rows = rows; this.loading = false;
        }, () => {
            if (generation !== this._generation) return;
            // Clear old notices rather than leave expired content displayed after a failed refresh.
            this.rows = []; this.loading = false;
        }));
    }
    trackAnnouncement(index: number, row: Announcement): number { return row.AnnouncementId; }
    ngOnDestroy(): void { this._generation++; this._request.unsubscribe(); this._subscriptions.unsubscribe(); }
}
